import tzlookup from 'tz-lookup'
import moment from 'moment-timezone'
import {
  REQUEST_BUILDINGS,
  RECEIVED_BUILDINGS,
  SHOW_ADD_BUILDING_FORM,
  CLOSE_ADD_BUILDING_FORM,
  UPDATE_BUILDING_FIELD,
  UPDATE_BUILDING_SUCCEDED,
  DELETE_BUILDING_SUCCEDED,
  CANCEL_BUILDING_IMAGE,
  CHANGE_BUILDING_IMAGE,
  SHOW_SPINNER_BUILDINGS,
  CHANGE_MARKER_POSITION,
  SHOW_ERROR_BUILDINGS,
  UPDATE_START_TIME,
  UPDATE_END_TIME,
  UPDATE_BRIVO,
  SHOW_TOKENS,
  CLOSE_TOKENS_MODAL,
  SHOW_TOKEN_FORM,
  CLOSE_TOKEN_FORM,
  UPDATE_NUMBER_OF_TOKENS,
  UPDATE_COMPANY_TOKEN,
  RECEIVED_TOKENS,
  DELETE_TOKEN_SUCCEDED,
  FETCH_COMPANIES_SUCCEDED,
  SHOW_GENERATE_TOKEN_ERROR,
  UPDATE_RESIDENTIAL,
  CHANGE_PAGE,
  SHOW_CUSTOMIZE_FORM,
  CLOSE_CUSTOMIZE_BUILDING_FORM,
  CHANGE_UNLOCK_IMAGE,
  CANCEL_UNLOCK_IMAGE,
  CHANGE_CHECKIN_IMAGE,
  CANCEL_CHECKIN_IMAGE,
  UPDATE_DO_CUSTOMIZE_BUILDING_FIELD,
  UPDATE_BOOK_CUSTOMIZE_BUILDING_FIELD,
  UPDATE_ASSEMBLY_CUSTOMIZE_BUILDING_FIELD,
  UPDATE_FILTER_CUSTOMIZE_BUILDING_FIELD,
  CHANGE_LOCK_IMAGE,
  CANCEL_LOCK_IMAGE,
  CHANGE_SELECTED_HOME_IMAGE,
  CANCEL_SELECTED_HOME_IMAGE,
  CANCEL_UNSELECTED_HOME_IMAGE,
  CHANGE_UNSELECTED_HOME_IMAGE,
  CHANGE_SELECTED_PROFILE_IMAGE,
  CANCEL_SELECTED_PROFILE_IMAGE,
  CANCEL_UNSELECTED_PROFILE_IMAGE,
  CHANGE_UNSELECTED_PROFILE_IMAGE
} from '../actions/buildings'

const buildingsReducer = (state = { companies: [], generateError: '' }, action) => {
  switch (action.type) {
    case SHOW_GENERATE_TOKEN_ERROR:
      return {
        ...state,
        generateError: action.generateError
      }
    case UPDATE_COMPANY_TOKEN:
      return {
        ...state,
        selectedTokenCompanyId: action.companyId
      }
    case FETCH_COMPANIES_SUCCEDED:
      return {
        ...state,
        companies: action.companies,
        showTokenGenerationForm: true
      }
    case DELETE_TOKEN_SUCCEDED:
      return {
        ...state,
        tokens: state.tokens.filter(token => {
          return token._id !== action.token._id
        })
      }
    case RECEIVED_TOKENS:
      return {
        ...state,
        tokens: action.json,
        showTokenGenerationForm: false,
        generateError: ''
      }
    case UPDATE_NUMBER_OF_TOKENS:
      return {
        ...state,
        numberOfTokens: action.numberOfTokens
      }
    case SHOW_TOKEN_FORM:
      return {
        ...state,
        showTokenGenerationForm: true,
        generateError: ''
      }
    case SHOW_CUSTOMIZE_FORM:
      return {
        ...state,
        building: action.building,
        showCustomizeForm: true
      }
    case CLOSE_TOKEN_FORM:
      return {
        ...state,
        showTokenGenerationForm: false
      }
    case SHOW_TOKENS:
      return {
        ...state,
        selectedBuildingForTokens: action.building
      }
    case CLOSE_TOKENS_MODAL:
      return {
        ...state,
        selectedBuildingForTokens: null
      }

    case CANCEL_BUILDING_IMAGE:
      return {
        ...state,
        building: { ...state.building, newImage: null }
      }

    case CANCEL_UNLOCK_IMAGE:
      return {
        ...state,
        building: { ...state.building, newUnlockImage: null }
      }

    case CANCEL_LOCK_IMAGE:
      return {
        ...state,
        building: { ...state.building, newLockImage: null }
      }

    case CANCEL_SELECTED_HOME_IMAGE:
      return {
        ...state,
        building: { ...state.building, newSelectedHomeImage: null }
      }

    case CANCEL_UNSELECTED_HOME_IMAGE:
      return {
        ...state,
        building: { ...state.building, newUnselectedHomeImage: null }
      }

    case CANCEL_CHECKIN_IMAGE:
      return {
        ...state,
        building: { ...state.building, newCheckInImage: null }
      }

    case CANCEL_SELECTED_PROFILE_IMAGE:
      return {
        ...state,
        building: { ...state.building, newSelectedProfileImage: null }
      }

    case CANCEL_UNSELECTED_PROFILE_IMAGE:
      return {
        ...state,
        building: { ...state.building, newUnselectedProfileImage: null }
      }

    case CHANGE_BUILDING_IMAGE:
      return {
        ...state,
        building: { ...state.building, newImage: action.image },
        showSpinnerBuildings: false
      }

    case CHANGE_UNLOCK_IMAGE:
      return {
        ...state,
        building: { ...state.building, newUnlockImage: action.unlockImage },
        showSpinnerBuildings: false
      }

    case CHANGE_LOCK_IMAGE:
      return {
        ...state,
        building: { ...state.building, newLockImage: action.lockImage },
        showSpinnerBuildings: false
      }

    case CHANGE_SELECTED_HOME_IMAGE:
      return {
        ...state,
        building: {
          ...state.building,
          homeImage: {
            ...state.building.homeImage,
            newSelectedHomeImage: action.selectedHomeImage
          },
          showSpinnerBuildings: false
        }
      }

    case CHANGE_UNSELECTED_HOME_IMAGE:
      return {
        ...state,
        building: {
          ...state.building,
          homeImage: {
            ...state.building.homeImage,
            newUnselectedHomeImage: action.unselectedHomeImage
          },
          showSpinnerBuildings: false
        }
      }

    case CHANGE_CHECKIN_IMAGE:
      return {
        ...state,
        building: { ...state.building, newCheckInImage: action.checkInImage },
        showSpinnerBuildings: false
      }

    case CHANGE_SELECTED_PROFILE_IMAGE:
      return {
        ...state,
        building: {
          ...state.building,
          profileImage: {
            ...state.building.profileImage,
            newSelectedProfileImage: action.selectedProfileImage
          },
          showSpinnerBuildings: false
        }
      }

    case CHANGE_UNSELECTED_PROFILE_IMAGE:
      return {
        ...state,
        building: {
          ...state.building,
          profileImage: {
            ...state.building.profileImage,
            newUnselectedProfileImage: action.unselectedProfileImage
          },
          showSpinnerBuildings: false
        }
      }

    case REQUEST_BUILDINGS:
      return {
        ...state,
        isFetching: true
      }

    case RECEIVED_BUILDINGS:
      return {
        ...state,
        isFetching: false,
        buildings: action.json.buildings,
        buildingsCount: action.json.buildingsCount,
        pageChanged: false
      }

    case SHOW_ADD_BUILDING_FORM:
      return {
        ...state,
        building: action.building,
        showUpdateBuildingForm: true,
        showSpinnerBuildings: false
      }

    case SHOW_SPINNER_BUILDINGS:
      return {
        ...state,
        showSpinnerBuildings: true
      }

    case CLOSE_ADD_BUILDING_FORM:
      return {
        ...state,
        building: null,
        showSpinnerBuildings: false,
        error: undefined
      }

    case CLOSE_CUSTOMIZE_BUILDING_FORM:
      return {
        ...state,
        building: null,
        showSpinnerBuildings: false,
        showCustomizeForm: false,
        error: undefined
      }

    case UPDATE_BRIVO:
      return {
        ...state,
        building: { ...state.building, brivo: action.value }
      }
    case UPDATE_RESIDENTIAL:
      return {
        ...state,
        building: { ...state.building, residential: action.enabled }
      }
    case UPDATE_BUILDING_FIELD:
      return {
        ...state,
        building: { ...state.building, [action.name]: action.value },
        event: null,
        company: null,
        // address1: " ",
        // address2: " ",
        showSpinnerBuildings: false,
        error: undefined
      }

    case UPDATE_DO_CUSTOMIZE_BUILDING_FIELD:
      return {
        ...state,
        building: {
          ...state.building,
          doCustomize: {
            ...state.building.doCustomize,
            [action.name]: action.value
          }
        },
        event: null,
        company: null,
        // address1: " ",
        // address2: " ",
        showSpinnerBuildings: false,
        error: undefined
      }

    case UPDATE_BOOK_CUSTOMIZE_BUILDING_FIELD:
      return {
        ...state,
        building: {
          ...state.building,
          bookCustomize: {
            ...state.building.bookCustomize,
            [action.name]: action.value
          }
        },
        event: null,
        company: null,
        // address1: " ",
        // address2: " ",
        showSpinnerBuildings: false,
        error: undefined
      }

    case UPDATE_ASSEMBLY_CUSTOMIZE_BUILDING_FIELD:
      return {
        ...state,
        building: {
          ...state.building,
          assemblyCustomize: {
            ...state.building.assemblyCustomize,
            [action.name]: action.value
          }
        },
        event: null,
        company: null,
        // address1: " ",
        // address2: " ",
        showSpinnerBuildings: false,
        error: undefined
      }

    case UPDATE_FILTER_CUSTOMIZE_BUILDING_FIELD:
      return {
        ...state,
        building: {
          ...state.building,
          filterCustomize: {
            ...state.building.filterCustomize,
            [action.name]: action.value
          }
        },
        event: null,
        company: null,
        // address1: " ",
        // address2: " ",
        showSpinnerBuildings: false,
        error: undefined
      }

    case UPDATE_BUILDING_SUCCEDED:
      let newBuildings = state.buildings.filter(building => {
        return building._id !== action.building._id
      })

      newBuildings.push(action.building)

      return {
        ...state,
        building: null,
        buildings: newBuildings,
        showSpinnerBuildings: false,
        showCustomizeForm: false,
        error: undefined
      }

    case SHOW_ERROR_BUILDINGS:
      return {
        ...state,
        error: action.error
      }

    case UPDATE_START_TIME:
      return {
        ...state,
        building: { ...state.building, [action.name]: action.value },
        event: null,
        company: null,
        showSpinnerBuildings: false,
        error: undefined
      }

    case UPDATE_END_TIME:
      return {
        ...state,
        building: { ...state.building, [action.name]: action.value },
        event: null,
        company: null,
        showSpinnerBuildings: false,
        error: undefined
      }

    case DELETE_BUILDING_SUCCEDED:
      return {
        ...state,
        building: null,
        buildings: state.buildings.filter(building => {
          return building._id !== action.building._id
        })
      }

    case CHANGE_MARKER_POSITION:
      return {
        ...state,
        position: action.position,
        building: {
          ...state.building,
          latitude: action.position.lat,
          longitude: action.position.lng,
          timeZone: tzlookup(action.position.lat, action.position.lng)
        },
        error: undefined,
        showSpinnerBuildings: false
      } 

      case CHANGE_PAGE:
        return {
          ...state,
          pageNumber: action.pageNumber,
          pageChanged: true
      }

    default:
      return {
        ...state
      }
  }
}

export default buildingsReducer



// WEBPACK FOOTER //
// ./src/reducers/buildings.js